import React, { createContext, Dispatch, ReactNode, SetStateAction, useContext, useState } from 'react';
import { User, Workspace } from '@/hooks/api/models';

type Props = {
  children: ReactNode;
};

export type WorkspaceContextType = {
  _w_?: Workspace;
  set_w_: Dispatch<SetStateAction<Workspace | undefined>>;
  me?: User;
  setMe: Dispatch<SetStateAction<User | undefined>>;
};

export const WorkspaceContext = createContext<WorkspaceContextType>({
  _w_: undefined,
  set_w_: () => {},
  me: undefined,
  setMe: () => {},
});

export const WorkspaceProvider = ({ children }: Props) => {
  const [_w_, set_w_] = useState<Workspace>();
  const [me, setMe] = useState<User>();

  return (
    <WorkspaceContext.Provider value={{ _w_, set_w_, me, setMe }}>{children}</WorkspaceContext.Provider>
  );
};

export const useCurrentWorkspace = () => {
  return useContext(WorkspaceContext);
};
